import State from '../db/models/state';

const STATES: Partial<State>[] = [
  { name: 'Alabama', code: 'AL' },
  { name: 'Alaska', code: 'AK' },
  { name: 'Arizona', code: 'AZ' },
  { name: 'Arkansas', code: 'AR' },
  { name: 'California', code: 'CA' },
  { name: 'Colorado', code: 'CO' },
  { name: 'Connecticut', code: 'CT' },
  { name: 'Delaware', code: 'DE' },
  { name: 'District of Columbia', code: 'DC' },
  { name: 'Florida', code: 'FL' },
  { name: 'Georgia', code: 'GA' },
  { name: 'Hawaii', code: 'HI' },
  { name: 'Idaho', code: 'ID' },
  { name: 'Illinois', code: 'IL' },
  { name: 'Indiana', code: 'IN' },
  { name: 'Iowa', code: 'IA' },
  { name: 'Kansas', code: 'KS' },
  { name: 'Kentucky', code: 'KY' },
  { name: 'Louisiana', code: 'LA' },
  { name: 'Maine', code: 'ME' },
  { name: 'Maryland', code: 'MD' },
  { name: 'Massachusetts', code: 'MA' },
  { name: 'Michigan', code: 'MI' },
  { name: 'Minnesota', code: 'MN' },
  { name: 'Mississippi', code: 'MS' },
  { name: 'Missouri', code: 'MO' },
  { name: 'Montana', code: 'MT' },
  { name: 'Nebraska', code: 'NE' },
  { name: 'Nevada', code: 'NV' },
  { name: 'New Hampshire', code: 'NH' },
  { name: 'New Jersey', code: 'NJ' },
  { name: 'New Mexico', code: 'NM' },
  { name: 'New York', code: 'NY' },
  { name: 'North Carolina', code: 'NC' },
  { name: 'North Dakota', code: 'ND' },
  { name: 'Ohio', code: 'OH' },
  { name: 'Oklahoma', code: 'OK' },
  { name: 'Oregon', code: 'OR' },
  { name: 'Pennsylvania', code: 'PA' },
  { name: 'Rhode Island', code: 'RI' },
  { name: 'South Carolina', code: 'SC' },
  { name: 'South Dakota', code: 'SD' },
  { name: 'Tennessee', code: 'TN' },
  { name: 'Texas', code: 'TX' },
  { name: 'Utah', code: 'UT' },
  { name: 'Vermont', code: 'VT' },
  { name: 'Virginia', code: 'VA' },
  { name: 'Washington', code: 'WA' },
  { name: 'West Virginia', code: 'WV' },
  { name: 'Wisconsin', code: 'WI' },
  { name: 'Wyoming', code: 'WY' },
];

export const stateOptions = STATES.map(state => ({
  label: state.name,
  value: state.code,
}));

/**
 * Helper function to get the LD flag for the list of states we show a disclaimer for, or return
 * the set of states used at the time this was ported from feature-config.json
 * @param medicalDisclaimerStates The LD feature flag for medical disclaimer states, which has the array under the key "values"
 * @returns the list of states for which the medical disclaimer should be shown
 */
export const getMedicalDisclaimerStates = (
  medicalDisclaimerStates?
): string[] => {
  // TODO: We can remove the defaults once settled with the LD flag, estimation is ~2023-05-15
  const defaultMedicalDisclaimerStates = [
    'AL',
    'AR',
    'DE',
    'GA',
    'HI',
    'LA',
    'MN',
    'MT',
    'NH',
    'NJ',
    'OK',
    'RI',
    'SC',
    'WV',
  ];
  if (!medicalDisclaimerStates?.values) {
    return defaultMedicalDisclaimerStates;
  }
  return medicalDisclaimerStates.values as string[];
};

/**
 * Helper function to get the LD flag for the list of states covered, or return
 * the set of states used at the time this was ported from feature-config.json
 * @param listStatesSupported the launch darkly JSON flag
 * @returns the list of state codes supported
 */
export const getIntakeStatesCovered = (listStatesSupported?): string[] => {
  // TODO: We can remove the defaults once settled with the LD flag, estimation is ~2023-05-15
  const defaultIntakeStatesCovered = [
    'AL',
    'AR',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'FL',
    'GA',
    'IA',
    'IL',
    'IN',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NC',
    'NE',
    'NH',
    'NJ',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'TN',
    'TX',
    'UT',
    'VA',
    'VT',
    'WA',
    'WI',
    'WV',
  ];
  if (!listStatesSupported?.intakeStatesCovered) {
    return defaultIntakeStatesCovered;
  }
  return listStatesSupported.intakeStatesCovered as string[];
};

export default STATES;
